// Keep this in step with the resource response policy in apps/api/src/routes/files.ts.
const INLINE_TYPES = new Set(['application/pdf', 'text/plain', 'image/png', 'image/jpeg', 'image/gif', 'image/webp']);

export function filterResources(resources, { search = '', sector = '', geography = '', category = '' } = {}) {
  const query = search.trim().toLowerCase();
  return resources.filter((resource) => {
    const matchesText = !query || resource.title?.toLowerCase().includes(query) || resource.description?.toLowerCase().includes(query);
    return matchesText && (!sector || resource.sector === sector) && (!geography || resource.geography === geography) && (!category || resource.category === category);
  });
}

export function fileAction(resource) {
  const inline = INLINE_TYPES.has((resource.file_type || '').toLowerCase());
  return { label: `${inline ? 'Open' : 'Download'} ${resource.title || 'resource'}`, download: !inline };
}
